type DefaultRoutes = {
  path: string;
  name: string;
};

export const DEFAULT_RESOURCE_ROUTES: DefaultRoutes[] = [
  {
    name: 'Videos',
    path: 'resource-videos',
  },
  {
    name: 'Documents',
    path: 'resource-documents',
  },
  {
    name: 'IRB Links',
    path: 'resource-irb-links',
  },
];
